import axios from "axios";
//import { ShowToast, toastType } from "./toast-service";
import { decodeData } from "../components/Comman/Util/Base64";
import { serverMsg } from "../config/messageconstant";
import { showNotification } from "../Pages/Landing/Landing.slice";

export function getApiHeader() {
  return {
    authorization: `${decodeData(localStorage.getItem("token"))}`,
    shouldrefresh: "true",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  };
}

const CancelToken = axios.CancelToken;
const source = CancelToken.source();
export function cancelAllOngoingRequest() {
  if (source) {
    source.cancel();
  }
}


export const apiPostForImage = async ({ url, postBody, params = {} }) => {
  const headers = {
    authorization: `${decodeData(localStorage.getItem("token"))}`,
    // shouldrefresh: "true",
    "Content-Type": "multipart/form-data",
    // "Access-Control-Allow-Origin": "*",
    shouldrefresh: "true",

    "Access-Control-Allow-Origin": "*",
  };
  return axios
    .post(process.env.REACT_APP_API_URL +url, postBody, {
      headers,
      ...{ params },
    })
    .then(({ data, status }) => {
      localStorage.setItem("loginCheck", "1");
      return { data, success: statusHandler(status) };
    })
    .catch((error) => {
      if (error) {
      if (error.response.status == "401") {
        localStorage.clear();
        localStorage.setItem("loginCheck", "0");
        window.location.replace("/login");
      } else {
        localStorage.setItem("loginCheck", "1");
      }
      return { success: statusHandler(400), data: {} };
    }else {
      return { success: false, data: {} };
    }
    });
};
export function apiPost({ url, postBody, params = {} }) {
  return axios
    .post(process.env.REACT_APP_API_URL +url, postBody, {
      headers: getApiHeader(),
      ...{ params },
    })
    .then(({ data, status }) => {
      localStorage.setItem("loginCheck", "1");
      return { data, success: statusHandler(status) };
    })
    .catch(( error ) => {
      if (error) {
        if (error.response.status == "401") {
          localStorage.clear();
          localStorage.setItem("loginCheck", "0");
          window.location.replace("/login");
        } else {
          localStorage.setItem("loginCheck", "1");
        }
        return { success: statusHandler(400), data: {} };
      } else {
        return { success: false, data: {} };
      }
    });
}

export function apiPostWithoutHeader({ url, postBody, params = {} }) {
  return axios
    .post(process.env.REACT_APP_API_URL +url, postBody, {
      ...{ params },
    })
    .then(({ data, status }) => {
      localStorage.setItem("loginCheck", "1");
      return { data, success: statusHandler(status) };
    })
    .catch(( error ) => {
      if (error) {
      if (error.response.status == "401") {
        localStorage.clear();
        localStorage.setItem("loginCheck", "0");
        window.location.replace("/login");
      } else {
        localStorage.setItem("loginCheck", "1");
      }
      return { success: statusHandler(400), data: {} };
      }else {
        return { success: false, data: {} };
      }
    });
}

export function apiGetWithoutHeader({ url, params = {} }) {
  return axios
    .get(process.env.REACT_APP_API_URL +url, {
      ...{ params },
    })
    .then(({ data, status }) => {
      localStorage.setItem("loginCheck", "1");
      return { data, success: statusHandler(status) };
    })
    .catch(( error ) => {
      if (error) {
      if (error.response.status == "401") {
        localStorage.clear();
        localStorage.setItem("loginCheck", "0");
        window.location.replace("/login");
      } else {
        localStorage.setItem("loginCheck", "1");
      }
      return { success: statusHandler(400), data: {} };
      
    }else {
      return { success: false, data: {} };
    }
    });
}
export function apiGet({ url, params = {} }) {
  console.log(url);
  return axios
    .get(process.env.REACT_APP_API_URL +url, {
      headers: getApiHeader(),
      ...{ params },
    })
    .then(({ data, status }) => {
      if (data.error) {
        window.location.replace("/login");
        return null;
      }
      localStorage.setItem("loginCheck", "1");
      return { data, success: statusHandler(status) };
    })
    .catch((error) => {
      if (error) {
      if (error.response.status == "401") {
        localStorage.clear();
        localStorage.setItem("loginCheck", "0");
        window.location.replace("/login");
      } else {
        localStorage.setItem("loginCheck", "1");
      }
      return { success: statusHandler(400), data: {} };
    }else {
      return { success: false, data: {} };
    }
    });
}
export function apiDelete({ url, params = {} }) {
  return axios
    .delete(process.env.REACT_APP_API_URL +url, {
      headers: getApiHeader(),
      ...{ params },
    })
    .then(({ data, status }) => {
      if (data.error) {
        window.location.replace("/login");
        return null;
      }
      localStorage.setItem("loginCheck", "1");
      return { data, success: statusHandler(status) };
    })
    .catch(( error ) => {
      if (error) {
      if (error.response.status == "401") {
        localStorage.clear();
        localStorage.setItem("loginCheck", "0");
        window.location.replace("/login");
      } else {
        localStorage.setItem("loginCheck", "1");
      }
      return { success: statusHandler(400), data: {} };
    }else {
      return { success: false, data: {} };
    }
    });
}

export function apiPostForDownload({ url, postBody, params = {} }) {
  return axios
    .post(process.env.REACT_APP_API_URL +url, postBody, {
      headers: {
        Authorization: `${decodeData(localStorage.getItem("token"))}`,
        shouldrefresh: "true",
      },
      responseType: "blob",
    })
    .then(({ data, status }) => {
      if (data.error && status === 200) {
        window.location.replace("/login");
        return null;
      }
      localStorage.setItem("loginCheck", "1");
      return { data, success: statusHandler(status) };
    })
    .catch(( error ) => {
      if(error){
        if (error.response.status == "401") {
        localStorage.clear();
        localStorage.setItem("loginCheck", "0");
        window.location.replace("/login");
      } else {
        localStorage.setItem("loginCheck", "1");
      }
      return { success: statusHandler(400), data: {} };
    }else {
      return { success: false, data: {} };
    }
    });
}

function statusHandler(status) {
  if (!status) return;
  switch (status) {
    case 200:
      return true;

    default:
      return false;
  }
}
